import { combineReducers } from "redux";

import { StackPacksReducer } from "./stackPacks/StackPacksReducer";
import type { EntitiesState } from "./EntitiesState";

export const EntitiesReducer = combineReducers<EntitiesState>({
	stackPacks: StackPacksReducer,
});
